




import {Component, Prop, Vue} from "vue-property-decorator";
import {EmployeeType} from "@/enums/type";

@Component({
    name: "EmployeeTypeLabel"
})
export default class extends Vue {
    @Prop({ required: true, type: Number })
    readonly type!: number;

    EmployeeType = EmployeeType;
}
